import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialLock: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M25.905 13.71h1.52v15.24h-1.52Zm-1.53 15.24h1.53v1.53h-1.53Zm-16.76 1.53h16.76V32H7.615Zm13.72-28.96h1.52v1.53h-1.52Zm-3.05 18.29h-1.52v-1.52h1.52v-1.53h-4.57v1.53h-1.53v3.04h1.53v1.53h1.52v4.57h1.53v-4.57h1.52v-1.53h1.52v-3.04h-1.52zM10.665 0h10.67v1.52h-10.67Zm-1.52 1.52h1.52v1.53h-1.52Zm16.76 12.19v-1.52h-1.53V3.05h-1.52v9.14H9.145V3.05h-1.53v9.14h-1.52v1.52zM6.095 28.95h1.52v1.53h-1.52Z\"/><path fill=\"currentColor\" d=\"M4.575 13.71h1.52v15.24h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialLock
